import React from 'react';
import {
  Box
} from '@chakra-ui/react';
const GameFrame = () => {

  return (
    <Box width={'full'} display={'flex'} bg={'green.100'} p={2} justifyContent={'center'}>
      <Box
        boxSize="border-box"
        border="4px dashed green"
        borderRadius="xl"
        overflow="hidden"
        width="65%"
        height="88vh"
        display="flex"
        justifyContent="center"
        boxShadow="md"
      >
        <iframe width={'100%'} src="https://harishbisu.github.io/Graphics/index.html"></iframe>
      </Box>
    </Box>
  );
};

export default GameFrame; 